export const About = 'help';
export const RequestHelp = 'request';

export const AboutView = `/${About}`;
export const RequestHelpView = `/${About}/${RequestHelp}`;

